import { type JSX, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { Dialog, OverlayDialogContent } from "common/components/ui/Dialog";

import { useActiveConversationContext } from "../context/ActiveConversationContext";
import useActiveConversationState from "../hooks/useActiveConversationState";
import { useNewConversation } from "../hooks/useNewConversation";

export default function MobileConversation({
  children,
}: {
  children: JSX.Element;
}) {
  const { activeConversation } = useActiveConversationContext();
  const { resetActiveConversation } = useActiveConversationState();
  const { newConversation } = useNewConversation();
  const navigate = useNavigate();

  // Open the conversation drawer both for existing conversations and for new
  // conversations started from a lead (e.g. "Send message" from a Lead sidebar),
  // which have no active conversation until the first message is sent.
  const shouldOpenConversation = !!activeConversation || !!newConversation;
  const [isOpen, setIsOpen] = useState(shouldOpenConversation);

  useEffect(() => {
    if (shouldOpenConversation) {
      setIsOpen(true);
    }
  }, [shouldOpenConversation]);

  return (
    <Dialog
      open={isOpen}
      onOpenChange={(open) => {
        setIsOpen(open);
        if (!open) {
          resetActiveConversation();
          navigate(null, { replace: true });
        }
      }}
    >
      <OverlayDialogContent>{children}</OverlayDialogContent>
    </Dialog>
  );
}
